const state = {
  alertCalendario: {
    status: false,
    show: false
  }
}

const mutations = {
  setAlertCalendario (state, obj) {
    state.alertCalendario = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/alertCalendario.js